angular.module('impactx.panel').directive('ixLotPanel', function () {
    return {
        restrict: 'EA',
        controller: 'LotPanelCtrl',
        controllerAs: 'lotPanelCtrl',
        scope: true,
        bindToController: {
            lot: "=",
            currentFilter: "="
        },
        templateUrl: 'shared/panel/templates/lot.panel.tmpl.html'
    }
});